module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5869_-_Cia_Termal_Beachewear_-_Moda_Feminina.1f408cd2.jpg";